import {
    Directive,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';
import { ConfirmService } from './confirm.service';
import { ConfirmDialogOptions } from './models';

@Directive({
    selector: '[appConfirm]',
    standalone: false,
})
export class ConfirmDirective {
    @Input('appConfirm') public options: ConfirmDialogOptions;

    @Output() public confirm = new EventEmitter<void>();
    @Output() public deny = new EventEmitter<void>();

    private isProcessing = false;

    public constructor(private readonly confirmService: ConfirmService) {}

    @HostListener('click', ['$event'])
    public async onClick(event: MouseEvent): Promise<void> {
        if (this.isProcessing) return;

        event.preventDefault();
        event.stopPropagation();

        this.isProcessing = true;

        try {
            if (this.options?.showDenyButton) {
                const result = await this.confirmService.confirmWithDeny(
                    this.options
                );
                if (result === 'confirm') {
                    this.confirm.emit();
                } else if (result === 'deny') {
                    this.deny.emit();
                }
            } else {
                const isConfirmed = await this.confirmService.confirm(
                    this.options ?? {}
                );
                if (isConfirmed) {
                    this.confirm.emit();
                }
            }
        } finally {
            this.isProcessing = false;
        }
    }
}
